var map = {
	"./icon-01.png": "Um0D",
	"./icon-02.png": "6Ilc",
	"./icon-03.png": "G/KD",
	"./icon-04.png": "bY88"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "j2rz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/value ^\.\/.*$
// module id = j2rz
// module chunks = 1